
import React, { Component, useState ,useEffect} from 'react';
import Axios from 'axios';
import Config  from "../Helpers/Config";
import Helpers from "../Helpers/Custom";

function Forms() {

    const [forms,setForms] = useState([]);
    localStorage.setItem("pageName","Forms");
    useEffect(() => {
        fetchForms();
    }, []);

    const fetchForms = ()=>{
        Axios.get(Config.api("api/forms/get-all"))
        .then( (response) => {
             var data =  response.data.INDIVIDUAL;
             setForms(data)
        })
        .catch((err) => {
        
        });
       
    }


    return (
        <div className="container-fluid">
            {forms && forms.map((list,i)=>(
                    <div className="col-xs-12 forms mt-5" key={i+"formsSegment"}>
                        <h2 className="form_title m-t-30 m-b-30">{list.type}</h2>
                        <ul className="list-group latestForms">
                            {
                                list && list.forms && list.forms.map((card,i)=>(
                                    <li className="list-group-item d-flex-justify" key={i+"forms"}>
                                        <span className="docName">{card?.name}</span>
                                            <div className="card-action float-end">
                                                <a className="btn btn-theme viewBtn" href={Helpers.viewFormURL(card.unique_id)}>View</a>
                                                <a className="btn btn-theme downloadBtn ms-2" target="_blank" rel="nofollow" href={Helpers.downloadFormURL(card.unique_id)} download="download">Download</a>
                                            </div>
                                    </li> 
                                ))
                            }
                           
                        </ul>
                    </div>
            ))
            }
            
        </div>
    )
}

export default Forms
